import useBootcampChallenges from "@hooks/game/bootcamp/use-bootcamp-challenges";
import useBootcampSession from "@hooks/game/bootcamp/use-bootcamp-session";

const useBootcamp = (userId?: string | null) => {
  const { challenges, refreshChallenges } = useBootcampChallenges(userId);
  const session = useBootcampSession({ refreshChallenges });

  return {
    challenges,
    ...session,
  };
};

export default useBootcamp;
